import { mergeWith, cond, isArray, nthArg, mapKeys } from 'lodash/fp';

export const mergeReplaceArrays = mergeWith(cond([[isArray, nthArg(1)]]));

/**
 * Returns a new object with updated keys
 * @param {Object} keyMap - map old keys to new ones, e.g. { oldKey: 'newKey' }
 * @param {Object} object - the object you want to update
 * @returns {Object} New object with updated keys
 */
export const updateKeys = (keyMap: any, object: any) => mapKeys((key) => keyMap[key] || key, object);

export const isJSON = (string: any) => {
  let testString = string;
  if (/^\s*$/.test(testString)) return false;
  testString = testString.replace(/\\(?:["\\/bfnrt]|u[0-9a-fA-F]{4})/g, '@');
  testString = testString.replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?/g, ']');
  testString = testString.replace(/(?:^|:|,)(?:\s*\[)+/g, '');
  return /^[\],:{}\s]*$/.test(testString);
};
